import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Programs from "@/pages/Programs";
import Team from "@/pages/Team";
import Fees from "@/pages/Fees";
import Policies from "@/pages/Policies";
import NQS from "@/pages/NQS";
import Enrolment from "@/pages/Enrolment";
import Contact from "@/pages/Contact";
import Announcements from "@/pages/Announcements";
import TranslationCorrections from "@/components/TranslationCorrections";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

const isTranslated = () => {
  const m = document.cookie.match(/googtrans=\/en\/([a-zA-Z-]+)/);
  return m && m[1] && m[1] !== "en";
};

function TranslatedNavigation() {
  useEffect(() => {
    if (!isTranslated()) return undefined;
    const handler = (e) => {
      const anchor = e.target.closest && e.target.closest('a[href^="/"]');
      if (anchor && anchor.href) {
        e.preventDefault();
        window.location.href = anchor.href;
      }
    };
    document.addEventListener("click", handler, true);
    return () => document.removeEventListener("click", handler, true);
  }, []);
  return null;
}

function App() {
  return (
    <div className="App font-body">
      <BrowserRouter>
        <ScrollToTop />
        <TranslatedNavigation />
        <TranslationCorrections />
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/programs" element={<Programs />} />
            <Route path="/team" element={<Team />} />
            <Route path="/fees" element={<Fees />} />
            <Route path="/policies" element={<Policies />} />
            <Route path="/nqs" element={<NQS />} />
            <Route path="/enrol" element={<Enrolment />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/announcements" element={<Announcements />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
        <Footer />
        <Toaster richColors position="top-center" />
      </BrowserRouter>
    </div>
  );
}

export default App;
